/**
 * 산문(@멘션) → 엔티티 흡수 배관의 추출기 (S2).
 * TipTap Mention 확장은 멘션을 <span data-type="mention" data-id="ENTITY_ID">로 렌더한다.
 * 본문 HTML에서 멘션된 엔티티 id를 뽑아 source 엔티티의 refs(아웃바운드 멘션 캐시)에 동기화한다.
 * DOM 비의존(정규식) — 브라우저(store)·노드(테스트) 양쪽에서 동작. 속성 순서 무관.
 */

const SPAN_TAG = /<span\b[^>]*?>/gi;

/** 본문 HTML에서 멘션된 엔티티 id 목록(중복 제거, 등장 순). */
export function extractMentionIds(html: unknown): string[] {
  if (typeof html !== 'string' || !html.includes('data-type="mention"')) return [];
  const ids = new Set<string>();
  let m: RegExpExecArray | null;
  SPAN_TAG.lastIndex = 0;
  while ((m = SPAN_TAG.exec(html)) !== null) {
    const tag = m[0];
    if (!/data-type="mention"/.test(tag)) continue;
    const id = /data-id="([^"]*)"/.exec(tag);
    if (id && id[1]) ids.add(id[1]);
  }
  return [...ids];
}

/** 멘션이 흡수되는 산문 필드(엔티티 타입별 1개). */
export const PROSE_FIELDS = new Set(['bodyJSON', 'bodyDraft']);
export const isProseField = (key: string): boolean => PROSE_FIELDS.has(key);
